import cx from 'classnames';
import assetUrl from 'mk/common/assetUrl';
import React from 'react';

interface OwnProps {
    icon: string;
    className?: string;
}

const Icon: React.StatelessComponent<OwnProps> = ({ icon, className }) => {
    if (icon.startsWith('fa-')) {
        return (
            <i className={cx('fa fa-lg', icon, className)} />
        );
    }

    let height;
    let width;
    switch (icon) {
        case 'action-file-delete':
        case 'action-file-delete-gray':
        case 'action-file-choose':
        case 'action-image-rotate':
            height = 28;
            break;
        case 'action-star':
        case 'action-unstar':
            width = 17;
            break;
        case 'action-add':
            height = 24;
            break;
        case 'action-add-white':
            height = 24;
            break;
        case 'action-add-photo':
            height = 16;
            width = 21;
            break;
        case 'green-check-mark-64':
            height = 64;
            break;
        case 'content-rating-great':
        case 'content-rating-not-ok':
        case 'content-rating-ok':
            height = 20;
            break;
        case 'action-reply':
            width = 22;
            break;
        case 'action-delete':
            width = 10;
            break;
        case 'fb':
            height = 20;
            width = 8;
            break;
        case 'envelope-plus':
            height = 23;
            width = 29;
            break;
    }

    // default icon is 16x16px
    height = height || 16;
    // if width is not specified we asume square icon
    width = width || height;

    const imgUrl = `${assetUrl}img/icons/bazaar/${icon}@2x.png`;

    return (
        // tslint:disable-next-line:jsx-ban-elements
        <img
            className={cx('icon', className)}
            src={imgUrl}
            height={`${height}px`}
            width={`${width}px`}
        />
    );
};

export default Icon;
